const ALL_INTEGRATIONS = [
  {
    id: 'google-photos',
    name: 'Google Photos',
    icon: 'mdi-google-photos',
    category: 'photo',
    authUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
    tokenUrl: 'https://www.googleapis.com/oauth2/v4/token',
    clientId: '560623732218-girqfb8f219m4fvisbd5hbr2cqeji77e.apps.googleusercontent.com',
    additionalData: {
      scope: 'https://www.googleapis.com/auth/photoslibrary.readonly',
      access_type: 'offline',
      prompt: 'consent'
    }
  }
]

/**
 * Find an integration by its ID, if not found, it return undefined
 *
 * @param {String} name
 *
 * @returns {Object}
 */
export function getIntegration (id) {
  return ALL_INTEGRATIONS.find(i => i.id === id)
}

/**
 * Find all integrations in a given category
 *
 * @param {String} category
 * @returns {Array}
 */
export function getIntegrationsByCategory (category) {
  return ALL_INTEGRATIONS.filter(i => i.category === category)
}

/**
 * Build a redirect URL based on the provided app id
 *
 * @param {String} app
 *
 * @returns {String}
 */
export function getRedirectURL (app) {
  return `https://us-central1-vjago-d95c4.cloudfunctions.net/integrations/${app}/redirect`
}
